import PropTypes from "prop-types";
import React from "react";
import { Alert, Button } from "@opendate-app/setlist";

import { attachableLineup } from "../../../../shared/offerLineupPerformer";

const CONSEQUENCE = "so the deal won't follow the artist into settlement, payouts, or reporting.";

const OfferPerformerBanner = ({ offers, performers, canManage, onAttach, onReview }) => {
  if (offers.length === 0) return null;

  const attachable = attachableLineup(performers);
  const single = offers.length === 1 ? offers[0] : null;
  const sole = single && attachable.length === 1 ? attachable[0] : null;
  const canAttach = Boolean(canManage && single && attachable.length > 0);

  const title = sole
    ? `${sole.artistable?.name} isn't attached to the offer.`
    : single
      ? `The offer for ${single.name} has no artist attached.`
      : `${offers.length} offers on this event have no artist attached.`;
  const description = single
    ? `It isn't linked to this event's lineup, ${CONSEQUENCE}`
    : `They aren't linked to this event's lineup, ${CONSEQUENCE}`;

  const actions = canAttach ? attachable.map((performer) => (
    <Button key={performer.id} variant="primary" size="sm" onClick={() => onAttach(single.id, performer)}>
      Attach {performer.artistable?.name} to offer
    </Button>
  )) : (
    <Button variant="secondary" size="sm" onClick={onReview}>Review offers</Button>
  );

  return (
    <div className="event-offer-performer-banner">
      <Alert color="warning" size="full-width" title={title} description={description} actions={actions} />
    </div>
  );
};

OfferPerformerBanner.propTypes = {
  offers: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.number, name: PropTypes.string })).isRequired,
  performers: PropTypes.arrayOf(PropTypes.object).isRequired,
  canManage: PropTypes.bool,
  onAttach: PropTypes.func.isRequired,
  onReview: PropTypes.func.isRequired,
};

export default OfferPerformerBanner;
